import { intranetActivitySchema } from '@gb-ticket/shared-types';
import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api';
import { intranetQueryKey } from '@/products/intranet/features/intranet/use-intranet';

export function useIntranetActivity(enabled: boolean) {
  return useQuery({
    queryKey: [...intranetQueryKey, 'activity', 'me'],
    queryFn: () => apiFetch('/intranet/activity/me', intranetActivitySchema),
    enabled,
  });
}
